import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API_CONFIG, API_HEADERS } from "../../../network/config/ApiConfig";
import { STORE_API_PATH, UOM_API_PATH } from "../../../network/config/apiPaths";
import { axiosApi } from "../../../network/service/config/AaxiosUtil";
import { consoleLog } from "../../../utils/log-utils";

function UpdateStorePrice() {
    const location=useLocation();
    const navigate=useNavigate()
    const price = location.state.price;
    const from = location.state.from;
    consoleLog("price",price)
    const[uom,setUom]=useState([]);
   const[product,setProduct]=useState({
    quantity:price.qty,
    measure:price.measure,
    price:price.price,
    offerPrice:price.offer_price,
    cgst:price.c_gst,
    sgst:price.s_gst,
    app:price.gsp_percentage,
    wholePrice:price.purchase_price,
   })
   


   useEffect(()=>{
    measurements()
   },[])
   useEffect(()=>{
    if((product.price!=""&&product.wholePrice!="")||product.offerPrice!=""){
        setProduct({
            ...product,
            app:Math.round(((+product.price)-(+product.wholePrice))/(+product.price)*100)-(+product.offerPrice)
        })
    }
   },[product.offerPrice,product.price,product.wholePrice])

   const measurements=async()=>{
     let data=await axios.get(API_CONFIG.API_HOST+UOM_API_PATH.LIST_PATH,{
        headers:API_HEADERS
     })
     consoleLog("",data.data.result)
     setUom(data.data.result)
   }

   const handleChange=(e)=>{
    let {name,value}=e.target    
        setProduct(
            {
                ...product,
                [name]:value
            }
        )
    
   }

   const listMeasure=()=>{
    return(
        <>
        {
            uom&&uom.length>=0 &&uom.map((obj,i)=>{
                return(
                    <option key={obj.id} value={obj.name}>{obj.name}</option>
                )
            })
        }
        </>
    )
   }

   const editItem = async() =>{
    let requestBody=JSON.stringify({
        storeId:price.store_id,
        gsp_percentage:product.app,
        productId:price.product_id,
        id:price.id,
        qty:product.quantity,
        measure:product.measure,
        quantity:product.quantity+product.measure,
        price:product.price,
        offer:product.offerPrice,
        s_gst:product.sgst,
        c_gst:product.cgst,
        purchase_price:product.wholePrice,
    })
   let apipath=API_CONFIG.API_HOST+STORE_API_PATH.PRICE_UPDATE
   consoleLog("path",apipath)
    let res=await axiosApi.post(apipath,requestBody,{
        headers:API_HEADERS
    }    
    )
    consoleLog("result",res)
    res.status===200&& navigate(-1)
   }

    return (
        <>
            <main className="container-fluid dashboard">
                <div className="row m-3">
                    <div className="col-12">
                        <h4>Update Price</h4>
                        <h6>{price.product_name}</h6>
                    </div>
                </div>
                <div className="row m-3">
                    <div className="d-flex flex-row col-4">
                        <div className="" style={{marginRight:10}}>
                            <label>Quantity</label>
                            <input 
                            placeholder="Quantity"
                            className="form-control"
                            name="quantity"
                            value={product.quantity} 
                            onChange={handleChange}
                            />
                        </div>
                        <div className="">
                        <label>Measure UOM</label>
                            <select 
                            className="form-control"
                            name="measure" 
                            value={product.measure}
                            onChange={handleChange}
                            >
                                <option>{"--select measurement"}</option>
                                {listMeasure()}
                            </select>
                        </div>
                    </div>
                    <div className="col-2">
                    <label>Whole Sale Price</label>
                        <input 
                        placeholder="Whole Price" 
                        className="form-control" 
                        name="wholePrice" 
                        value={product.wholePrice} 
                        onChange={handleChange}
                        />
                    </div>
                    <div className="col-2">
                    <label>Offer %</label>
                        <input 
                        placeholder="Offer Price" 
                        className="form-control" 
                        name="offerPrice" 
                        value={product.offerPrice} 
                        onChange={handleChange}
                        />
                    </div>
                    <div className="col-2">
                    <label>Sale Price</label>
                        <input 
                        placeholder="Price" 
                        className="form-control" 
                        name="price" 
                        value={product.price} 
                        onChange={handleChange}
                        />
                        
                    </div>

                </div>
                <div className="row m-3">
                    <div className="col-3">
                    <label>CGST %</label>
                        <input 
                        placeholder="CGST" 
                        className="form-control" 
                        name="cgst" 
                        value={product.cgst}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="col-3">
                    <label>SGST %</label>
                        <input 
                        placeholder="SGST" 
                        className="form-control" 
                        name="sgst" 
                        value={product.sgst}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="col-3">
                    <label>App %</label>
                        <input 
                        placeholder="App %" 
                        className="form-control" 
                        name="app" 
                        value={product.app}
                        // onChange={handleChange}
                        />
                        
                    </div>
                </div>
                <div className="row m-3 d-flex flex-row justify-content-center">
                    <div className="col-3 mt-5">
                    <button className="btn btn-danger me-2" onClick={()=>navigate(-1)}>Close</button>
 
                    <button className="btn btn-success" onClick={()=>editItem()}>Update</button>
                    </div>
                </div>
            </main>
           {consoleLog("product",product)}
        </>
    )
}
export default UpdateStorePrice;